import { render, staticRenderFns } from "./CsAsignacionContableCecoAfe.vue?vue&type=template&id=31518b37"
import script from "./CsAsignacionContableCecoAfe.vue?vue&type=script&lang=js"
export * from "./CsAsignacionContableCecoAfe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports